import Axios from "axios";
import {
  SET_OTHER_INFO_LIST,
  UNSET_OTHER_INFO_LIST,
  SET_OTHER_INFO_DETAILS,
  UNSET_OTHER_INFO_DETAILS,
} from "@/store/mutation-types";
import {
  getOtherInfoList,
  getOtherInfoById,
  getOtherInfoByEmployee,
  saveUpdateOtherInfo,
  saveEmployeeOtherInfo,
  updateOtherInfo,
  deleteOtherInfo,
  bulkDeleteOtherInfo,
} from "@/store/api";

const state = {
  otherInfoList: [],
  otherInfoDetails: null,
};

const getters = {
  getOtherInfoList(state) {
    return state.otherInfoList;
  },
  getOtherInfoDetails(state) {
    return state.otherInfoDetails;
  },
};

const mutations = {
  [SET_OTHER_INFO_LIST](state, data) {
    state.otherInfoList = data;
  },
  [UNSET_OTHER_INFO_LIST](state) {
    state.otherInfoList = [];
  },
  [SET_OTHER_INFO_DETAILS](state, data) {
    state.otherInfoDetails = data;
  },
  [UNSET_OTHER_INFO_DETAILS](state) {
    state.otherInfoDetails = null;
  },
};

const actions = {
  getOtherInfoList({ commit }, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(getOtherInfoList, params)
        .then((response) => {
          commit(SET_OTHER_INFO_LIST, response.data.data || []);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_OTHER_INFO_LIST);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getOtherInfoById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.get(getOtherInfoById(id))
        .then((response) => {
          commit(SET_OTHER_INFO_DETAILS, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_OTHER_INFO_DETAILS);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  getOtherInfoByEmployee({ commit }, employeeId) {
    return new Promise((resolve, reject) => {
      Axios.get(getOtherInfoByEmployee(employeeId))
        .then((response) => {
          commit(SET_OTHER_INFO_DETAILS, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_OTHER_INFO_DETAILS);
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveOtherInfo({ commit }, otherInfoData) {
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateOtherInfo, otherInfoData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  saveEmployeeOtherInfo({ commit }, { employeeId, otherInfoData }) {
    return new Promise((resolve, reject) => {
      Axios.post(saveEmployeeOtherInfo, {
        employee_id: employeeId,
        other_info_data: otherInfoData,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  updateOtherInfo({ commit }, { id, otherInfoData }) {
    return new Promise((resolve, reject) => {
      Axios.put(updateOtherInfo(id), otherInfoData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  deleteOtherInfo({ commit }, id) {
    return new Promise((resolve, reject) => {
      Axios.delete(deleteOtherInfo(id))
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },

  bulkDeleteOtherInfo({ commit }, ids) {
    return new Promise((resolve, reject) => {
      Axios.post(bulkDeleteOtherInfo, { ids })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          // Use root loading mutation from the global store
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

